import { render, staticRenderFns } from "./SensorsAndRelaysNaming.vue?vue&type=template&id=04ad8daf&scoped=true&"
import script from "./SensorsAndRelaysNaming.vue?vue&type=script&lang=js&"
export * from "./SensorsAndRelaysNaming.vue?vue&type=script&lang=js&"
import style0 from "./SensorsAndRelaysNaming.vue?vue&type=style&index=0&id=04ad8daf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ad8daf",
  null
  
)

export default component.exports